import React from 'react';
import { motion } from 'framer-motion';
import { 
  FaProjectDiagram, 
  FaCogs, 
  FaChartLine, 
  FaHeartbeat, 
  FaCloud 
} from 'react-icons/fa';

const Services = () => {
  const services = [
    {
      id: 1,
      title: "Project Management & Agile Leadership",
      description: "Leading sprint planning, resource allocation, and delivery cycles that ensure measurable outcomes.",
      icon: FaProjectDiagram
    },
    {
      id: 2,
      title: "Product & Technical Strategy",
      description: "Translating business goals into technical architecture and execution.",
      icon: FaCogs
    },
    {
      id: 3,
      title: "Data & BI Solutions",
      description: "Designing dashboards and SQL-driven analytics to uncover actionable insights.",
      icon: FaChartLine
    },
    {
      id: 4,
      title: "Healthcare Compliance Platforms",
      description: "Building healthcare compliance systems that improve dialysis workflow automation and compliance tracking.",
      icon: FaHeartbeat
    },
    {
      id: 5,
      title: "DevOps & Cloud Management",
      description: "Managing CI/CD pipelines, database environments, and deployments on DigitalOcean.",
      icon: FaCloud
    }
  ];

  const ServiceCard = ({ service, index }) => {
    const IconComponent = service.icon;

    return (
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, delay: index * 0.1 }}
        whileHover={{ 
          scale: 1.05,
          boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)"
        }}
        className="service-card group cursor-pointer"
      >
        <div className="service-card-content">
          {/* Icon */}
          <motion.div
            whileHover={{ rotate: 5, scale: 1.1 }}
            className="service-icon group-hover:shadow-lg"
          >
            <IconComponent />
          </motion.div>

          {/* Content */}
          <div className="service-text">
            <h3 className="service-title group-hover:text-teal">
              {service.title}
            </h3>
            <p className="service-description">
              {service.description}
            </p>
          </div>

          {/* Hover indicator */}
          <motion.div
            initial={{ width: 0 }}
            whileHover={{ width: '100%' }}
            className="service-indicator"
          />
        </div>
      </motion.div>
    );
  };

  return (
    <div className="container">
      {/* Header */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        <h2 className="section-title">
          How I Can Help Your Business
        </h2>
        <p className="services-subtitle">
          Delivering end-to-end solutions that bridge technical excellence with business strategy
        </p>
      </motion.div>

      {/* Services Grid */}
      <div className="services-grid">
          {services.map((service, index) => (
            <ServiceCard
              key={service.id}
              service={service}
              index={index}
            />
          ))}
        </div>

        {/* Call to Action */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.5 }}
          className="services-cta"
        >
          <div className="services-cta-card">
            <h3 className="services-cta-title">
              Ready to Transform Your Digital Strategy?
            </h3>
            <p className="services-cta-description">
              Let's discuss how I can help accelerate your project delivery and technical excellence.
            </p>
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={() => {
                const element = document.querySelector('#contact');
                if (element) {
                  element.scrollIntoView({ behavior: 'smooth' });
                } else {
                  // Fallback for routing-based navigation
                  window.location.href = '/contact';
                }
              }}
              className="services-cta-button"
            >
              Get In Touch
            </motion.button>
          </div>
        </motion.div>
    </div>
  );
};

export default Services;